import { render, staticRenderFns } from "./loginViewPage.vue?vue&type=template&id=48060dbf&scoped=true&"
import script from "./loginViewPage.vue?vue&type=script&lang=js&"
export * from "./loginViewPage.vue?vue&type=script&lang=js&"
import style0 from "./loginViewPage.vue?vue&type=style&index=0&id=48060dbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48060dbf",
  null
  
)

export default component.exports